<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KrRjYV/tc-custom/9781398434899.jpg?1745521790978" alt="This image is the cover for the book The Chocolate Elephant Part 1"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Chocolate Elephant Part 1
      </h1>
      <p class="bookDescription body article font2">
        <p>Putting Information Technology first and the business second is putting the cart before the horse. In most organisations, there seems to be a disconnect between the business and Information Technology, and in some regards, IT is looked on as the silver bullet that can be used to resolve all problems and issues. This has occurred due to Information Technology becoming so embedded in organisations and being required for the execution of most business processes. It should be noted that Information Technology is a tool used to enable the execution of a business process. It is an important tool, but nonetheless, it is only a tool. Organisations need to shift the focus back to the business and ensure that the technology they are using fits in with the requirements of their business processes. This will ensure that businesses become more efficient and effective and that they are only using and being supported for the technology that they require. Only in very exceptional circumstances, should a business process be altered to fit in with Information Technology.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jim Kelly
      </h2>
      
      <p class="authorDescription body article">Jim Kelly was born in Irvine, Scotland in 1967. He studied computing at Bell College of Technology in Hamilton and obtained a Higher National Diploma in Computer Studies. Jim has over 30 years’ experience working in Information Technology (IT) across many industry sectors including Defence, Finance, Utilities, and Local and Central Government. He has worked in Edinburgh, London and Wellington, New Zealand. More recently, Jim is focused on Business Process Management and IT Service Management best practices, rather than on the technical side. He has obtained a number of industry recognised ITIL certifications. Jim has dual UK and New Zealand Citizenship and today he resides on the Kapiti Coast in New Zealand with his partner Carmel and their rescue dog, Rizzo.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?41ec7868